import * as TestimonialApi from 'api/TestimonialApi';
import * as DigitalAssetApi from 'api/DigitalAssetApi';
import {convertToReadUrl} from 'api/DigitalAssetApi';
import * as ImageResizer from 'lib/ImageResizer';
import {cloneDeep, filter, find, indexOf} from 'lodash';
import {toggleNotification} from './showNotification';
import AnalyticsGateway from 'lib/AnalyticsGateway';

const UPDATE = 'testimonials/actions/UPDATE';
const LOADED = 'testimonials/actions/LOADED';
const REMOVE = 'testimonials/actions/REMOVE';
const SORT = 'testimonials/actions/SORT';

export class Testimonial {
  constructor(index = 0, title = undefined, image = undefined, description = undefined, author = undefined, month = undefined, year = undefined, id = undefined) {
    this.index = index;
    this.title = title;
    this.image = image;
    this.description = description;
    this.author = author;
    this.month = month;
    this.year = year;
    this.id = id;
  }
}

function date(month, year) {
  let result = '';
  if (month) result = month;
  if (year) result = result + ' ' + year;
  return (result.trim() === '' ? undefined : result.trim());
}

export const initialState = {
  rental: [],
  cma: [],
};

const TestamonialsDuck = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE: {
      const reportType = action.payload.reportType;
      const newState = cloneDeep(state);
      const newTestimonials = newState[reportType] ? [...newState[reportType]] : [];
      const newTestimonial = action.payload.testimonial[0];

      newTestimonials[newTestimonial.index] = newTestimonial;
      newState[reportType] = newTestimonials;
      return newState;
    }
    case LOADED: {
      return {...action.payload.data};
    }
    case REMOVE: {
      let newState = cloneDeep(state);
      let newTestimonials = newState[action.payload.reportType]
        .filter(t => t.index !== action.payload.testimonial.index);

      newTestimonials.forEach((testimonial, idx) => testimonial.index = idx);

      newState[action.payload.reportType] = newTestimonials;
      return newState;
    }
    case SORT: {
      let newState = cloneDeep(state);
      let newTestimonials = [...newState[action.payload.reportType]];
      newState[action.payload.reportType] = newTestimonials.sort((a, b) => a.index > b.index ? 1 : -1);
      return newState;
    }
    default:
      return state;
  }
};

export default TestamonialsDuck;


export function reindexTestimonials(testimonials, oldIndex, newIndex) {
  let movedItem = testimonials[oldIndex];
  let updatedTestimonials = testimonials.filter(t => (oldIndex < newIndex && t.index > oldIndex && t.index <= newIndex)
    || (oldIndex > newIndex && t.index < oldIndex && t.index >= newIndex));
  updatedTestimonials.forEach(t => {
    t.index += (oldIndex > newIndex) ? 1 : -1;
  });

  movedItem.index = newIndex;
  if (!find(updatedTestimonials, movedItem)) {
    updatedTestimonials.push(movedItem);
  }
  return testimonials;
}

export function sortTestimonials(oldIndex, newIndex, reportType) {
  return {
    type: SORT,
    payload: {
      oldIndex: oldIndex,
      newIndex: newIndex,
      reportType: reportType,
    }
  };
}

export function updateTestimonials(testimonials, reportType) {
  return {
    type: UPDATE,
    payload: {
      testimonial: testimonials,
      reportType: reportType
    }
  };
}

export function removeTestimonial(testimonial, reportType) {
  return {
    type: REMOVE,
    payload: {
      testimonial: testimonial,
      reportType: reportType
    }
  };
}

export function testimonialsLoaded(testimonials) {
  return {
    type: LOADED,
    payload: testimonials
  };
}

export function moveTestimonials(oldIndex, newIndex) {
  return (dispatch, getState) => {
    const {reportType: {value: reportTypeValue}} = getState();
    dispatch(toggleNotification(true));
    let testimonials = getState().testimonials[reportTypeValue];
    let updatedTestimonials = reindexTestimonials(testimonials, oldIndex, newIndex);
    TestimonialApi.update(updatedTestimonials, reportTypeValue);
    dispatch(sortTestimonials(oldIndex, newIndex, reportTypeValue));
    setTimeout(() => {
      dispatch(toggleNotification(false));
    }, 2000);
  };
}

export function uploadTestimonialImage(testimonial, file, onFileUpload) {
  return async (dispatch, getState) => {
    const {propertyDetail} = getState();
    const reSizedFile = await ImageResizer.preview(file, 266, 175);
    const payload = {
      file: reSizedFile,
      source: 'upload-testimonial-image',
      propertyId: propertyDetail.propertyId,
    };
    const {data: {url}} = await DigitalAssetApi.uploadDigitalAsset(payload);
    const fileUrl = convertToReadUrl(url);
    onFileUpload(fileUrl);
  };
}

export function saveTestimonial(testimonial, message) {
  return async (dispatch, getState) => {
    const {reportType: {value: reportTypeValue}} = getState();
    dispatch(toggleNotification(true, message));
    if (!testimonial.id) {
      testimonial.index = getState().testimonials[reportTypeValue].length;
    }
    let updatedTestimonial = await TestimonialApi.update([testimonial], reportTypeValue);
    dispatch(updateTestimonials(updatedTestimonial.data, reportTypeValue));

    AnalyticsGateway.sendEvent({
      eventName: (testimonial.id ? 'Edit' : 'Add') + ' Testimonial',
      properties: [
        {label: 'Title', value: testimonial.title},
        {label: 'Image Included', value: testimonial.image !== undefined},
        {label: 'Description', value: testimonial.description},
        {label: 'Author', value: testimonial.author},
        {label: 'Date', value: date(testimonial.month, testimonial.year)}
      ]
    });

    setTimeout(() => {
      dispatch(toggleNotification(false));
    }, 2000);
  };
}

export function deleteTestimonial(testimonial, message) {
  return async (dispatch, getState) => {
    const {reportType: {value: reportTypeValue}} = getState();
    dispatch(toggleNotification(true, message));

    let testimonials = getState().testimonials[reportTypeValue];
    let idx = indexOf(testimonials, testimonial);
    let updatedTestimonials = reindexTestimonials(testimonials, idx, testimonials.length - 1);
    let reducedList = filter(updatedTestimonials, t => t.id !== testimonial.id);

    TestimonialApi.remove(testimonial.id);
    dispatch(removeTestimonial(testimonial, reportTypeValue));

    TestimonialApi.update(reducedList, reportTypeValue);

    AnalyticsGateway.sendEvent({
      eventName: 'Delete Testimonial',
      properties: [
        {label: 'Title', value: testimonial.title},
        {label: 'Image Included', value: testimonial.image !== undefined},
        {label: 'Description', value: testimonial.description},
        {label: 'Author', value: testimonial.author},
        {label: 'Date', value: date(testimonial.month, testimonial.year)}
      ]
    });

    setTimeout(() => {
      dispatch(toggleNotification(false));
    }, 2000);
  };
}

export function loadTestimonials() {
  return async (dispatch) => {
    const response = await TestimonialApi.list();
    dispatch(testimonialsLoaded(response));
  };
}
